import { useMutation, useQueryClient } from '@tanstack/react-query';

import { authApi } from '../auth.api';
import { useAuthStore } from '../auth.store';
import type { LoginPayload } from '../types';

/**
 * Ejecuta el inicio de sesión y publica la sesión en el store global.
 *
 * El componente que lo usa sólo necesita capturar el error para mostrar el
 * mensaje correspondiente (`resolveAuthErrorMessage`).
 */
export function useLogin() {
  const queryClient = useQueryClient();
  const setSession = useAuthStore((state) => state.setSession);
  const setAuthenticating = useAuthStore((state) => state.setAuthenticating);

  return useMutation({
    mutationFn: (payload: LoginPayload) => {
      setAuthenticating();
      return authApi.login(payload);
    },
    onSuccess: (session) => {
      // Evita datos de una sesión anterior (otro usuario u otra estación).
      queryClient.clear();
      setSession(session);
    },
    onError: () => {
      useAuthStore.setState({ status: 'anonymous' });
    },
  });
}
